import { notification } from '../../../components/Notifications'

type SetTaskFn = (taskId: string, message: string, successMessage?: string, onComplete?: () => void) => void

interface CloseSurveySuccessDeps {
  setTask: SetTaskFn
  refreshSections: () => void
  refreshClosedView: () => void
}

interface CloseSurveyVariables {
  wasLastLiveSection?: boolean
}

/**
 * Success handler for the row-level Close Survey mutation.
 *
 * Refresh target depends on `variables.wasLastLiveSection`: closing the only section in the
 * current (Live & Upcoming) view empties it, so we switch to the Closed view
 * (`refreshClosedView`) instead of refetching the now-empty view (`refreshSections`).
 *
 * 200 path → snackbar + immediate refresh.
 * 202 path → register the background task with `setTask`, passing the chosen refresh as the
 *            per-task `onComplete` so the table updates when the task lands.
 */
export const createCloseSurveySuccessHandler = ({ setTask, refreshSections, refreshClosedView }: CloseSurveySuccessDeps) =>
  (data: any, variables?: CloseSurveyVariables): void => {
    const refresh = variables?.wasLastLiveSection === true ? refreshClosedView : refreshSections
    if (data?.status === 202) {
      const { taskId, message } = data?.data ?? {}
      if (taskId) {
        setTask(taskId, message ?? 'Closing survey...', 'Survey section closed successfully.', refresh)
        notification('Closing survey', { variant: 'info', subTitle: 'Your changes are being applied in the background.' })
      }
      return
    }
    notification(data?.data?.message ?? 'Survey closed successfully', { variant: 'success' })
    refresh()
  }
